export const CHATBOT_SOCKET_EVENTS = {
    CONNECTION: 'connection',
    ROOM_JOIN: 'room.join',
    MANUAL_QUERY: 'manual.query',
    MANUAL_QUERY_RESPONSE: 'manual.query.response',
    MANUAL_QUERY_ERROR: 'manual.query.error',
    LIVE_SALE_PITCH_STREAM: 'liveSalePitch.agentStreamResponse',
    TRANSCRIPTION_STARTED: 'transcription.started',
    MANUAL_QUERY_SESSION_START: 'manual.querySessionStart',
    MANUAL_QUERY_SESSION_CREATED: 'manual.querySessionCreated',
    AGENT_QUERY_END_FE: 'liveSalePitch.agentQueryEndFE',
    WEBSOCKET_SEND_TO_ROOM_SOCKETS: 'websocket.sendToRoomSockets',
}

export const CHATBOT_SOCKET_EVENTS_GOOGLE_MEET = {
    GOOGLE_MEET_CALL_START: 'googleMeet.googleMeetCallStart',
    GOOGLE_MEET_CUSTOMER_SESSION_END: 'googleMeet.customerSessionEnd',
    GOOGLE_MEET_BOT_ENTERED_CALL: 'googleMeet.botEnteredCall',
    GOOGLE_MEET_CUSTOMER_OUTPUT_STREAM: 'googleMeet.customerOutputStream',
    GOOGLE_MEET_CUSTOMER_INPUT_TRANSCRIPT: 'googleMeet.customerInputTranscript',
    GOOGLE_MEET_PAUSE_TRANSCRIPTION: 'googleMeet.pauseTranscription',
    GOOGLE_MEET_RESUME_TRANSCRIPTION: 'googleMeet.resumeTranscription',
}

export const CHATBOT_SOCKET_EVENTS_GOOGLE_MEET_INHOUSE = {
    GOOGLE_MEET_INHOUSE_BOT_CALL_STARTED: 'googleMeetInHouse.botCallStarted',
    GOOGLE_MEET_INHOUSE_SESSION_END: 'googleMeetInHouse.sessionEnd',
    GOOGLE_MEET_INHOUSE_AI_RESPONSE_STREAM: 'googleMeetInHouse.aiResponseStream',
    GOOGLE_MEET_INHOUSE_TRANSCRIPT_LIVE: 'googleMeetInHouse.transcriptLive',
    GOOGLE_MEET_INHOUSE_PAUSE_TRANSCRIPTION: 'googleMeetInHouse.pauseTranscription',
    GOOGLE_MEET_INHOUSE_RESUME_TRANSCRIPTION: 'googleMeetInHouse.resumeTranscription',
}

export const CHATBOT_SOCKET_EVENTS_VOCAL_TRANS_ENG = {
    CALL_STREAM_START_OUTPUT: 'vocalTransEng.callStreamStartOutput',
    TRANSCRIPT_RESPONSE_RECEIVED: 'vocalTransEng.transcriptResponseReceived',
    CALL_END_OUTPUT_RECEIVED: 'vocalTransEng.callEndOutputReceived',
    TRANSCRIPT_SUMMARY_OUTPUT: 'vocalTransEng.transcriptSummaryOutput',
    ERROR: 'vocalTransEng.error',
}